export default {"src":"/_next/static/media/wbtc.d5fa58cc.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};